module.exports = __webpack_public_path__ + "static/media/guardian.f70e328f.svg";